import microuniversoApi from "app/api/microuniversoApi"
import { PagedMessageResponse } from "app/api/types/PagedMessageResponse"
import { Breadcrumb2Container } from "app/components/breadcrumb2/Breadcrumb2Container"
import { useMenuConsultaProduto } from "app/components/menu-consulta-produtos/useMenuConsultaProduto"
import { useMenuSubConsulta } from "app/components/menu-sub-consulta-produto/useMenuSubConsultaProduto"
import { IItemOrcamento } from "app/types/IItemOrcamento"
import { tratamentoErroPadrao } from "app/use-cases"
import { Dict } from "app/utils/Dict"
import globalMU from "globalMU"
import React, { useEffect, useRef, useState } from "react"
import { Parametro } from "app/types/Parametro";
import { obterParametros } from "app/use-cases/parametro/obterParametros";
import { EncomendaProduto, Encomendas } from "./EncomendaProduto"
import { EntitesDadosEstoque } from "../../Estoque"

export type EncomendaProdutoContainerProps = {
    estoqueSelecionado: EntitesDadosEstoque
    item: IItemOrcamento
    //dadosEstoque: PagedMessageResponse<EntitesDadosEstoque>
    onVoltar: () => void,
    onRemover: () => void,
    passos: Dict<string,() => void>,
    foraOrcamento: boolean 
}

export const EncomendaProdutoContainer = (props: EncomendaProdutoContainerProps) => {

    const [dadosReservaProduto, setDadosReservaProduto] = useState<Encomendas[]>()
    const [parametros, setParametros] = useState<Parametro[]>([])
    const passosInterno = useRef<Dict<string, () => void>>(new Dict(Object.assign({}, props.passos.map))) 

    const atualizarParametros = async () => {
        setParametros(
          await obterParametros({
            nomes: [
              "TRATAR_VENDAS_SOB_ENCOMENDA"
            ]
          })
        )
      }

    const valorParametro = (nome: string) => parametros.find((p) => p.Nome == nome)?.Valor;
  
    const onObterReserva = async () => {
        try {
            const resposta = await microuniversoApi.Produto.dadosEncomendaProduto({
                CodigoProduto: props.estoqueSelecionado.Codigo,
                Filial: props.estoqueSelecionado.Filial
            }) 
            !("HasErrors" in resposta) ? setDadosReservaProduto(resposta) : setDadosReservaProduto([])
            
        } catch (e) {
            tratamentoErroPadrao(e)
        } finally {
            globalMU.unblockUI()
        }
    }

    const onVoltar = () => {
        props.onRemover()
        props.onVoltar()
    }

    const onPassoSelecionado = (passo: string) => {
        props.onRemover()
        passosInterno.current.get(passo)()
    }

    useMenuSubConsulta(props)
    useMenuConsultaProduto(new Dict(Object.assign({}, props.passos.remove("Estoque do Produto").map)), props.onVoltar, props.item, props.foraOrcamento)

    useEffect(() => {
        passosInterno.current.set("Estoque do Produto", () => props.onVoltar())
        passosInterno.current.set("Encomenda", () => { })
        onObterReserva()
        atualizarParametros()
    }, [])

    return (
        <>
            <Breadcrumb2Container
                passos={passosInterno.current.keysToList()}
                exibirBotaoLimpar={false}
                exibirBotaoVoltar={true}
                onBotaoVoltarClicado={onVoltar}
                onPassoSelecionado={onPassoSelecionado}
                id="EncomendaProdutoBreadcrumb"
            />
            <br />

            <EncomendaProduto 
                dados={dadosReservaProduto} 
            />
        </>
    )
}